<template>
  <fragment>
    <a
      v-if="type === 'link'"
      :disabled="disabled"
      :class="classes + ' button'"
      @click="action"
      ><slot></slot
    ></a>
    <button
      v-if="type === 'button' || type === 'submit'"
      :disabled="loading === true || disabled === true"
      :class="classes + ' button'"
      @click="action"
    >
      <slot v-if="!loading"></slot>
      <Spinner v-if="loading"></Spinner>
    </button>
  </fragment>
</template>

<script>
import Spinner from "@/components/Layout/Spinner";
export default {
  name: "TButton",
  components: { Spinner },
  props: {
    type: {
      required: false,
      default: () => "button",
      type: String,
    },
    disabled: {
      required: false,
      default: () => false,
      type: Boolean,
    },
    loading: {
      required: false,
      default: () => false,
      type: Boolean,
    },
    classes: {
      required: false,
      default: () => "",
      type: String,
    },
    action: Function,
  },
};
</script>

<style scoped>
a.button,
button {
  @apply bg-accent rounded-lg text-base p-2 border-accent border cursor-pointer relative w-full;
  @apply text-white;

  height: 41px;
  line-height: 1.0625rem;

  &:disabled {
    cursor: default;
  }

  &:focus {
    @apply outline-none;
  }

  &:hover {
    @apply text-primary;
  }

  &.outline {
    background-color: transparent;
    @apply border border-accent text-ff02 !important;

    &:hover {
      @apply text-white bg-accent border border-white !important;
    }
  }

  &.full-width {
    @apply inline-block text-center;
  }

  .icon {
    @apply font-thin;
    font-size: 3rem;
    transform: rotate(0);
    transition: 0.5s;

    &.active {
      transition: 0.5s;
      transform: rotate(-45deg);
    }
  }

  &::v-deep .loader {
    @apply inline right-4 absolute top-0 h-8 my-auto mx-auto left-0 right-0;
    transform: scale(0.3);
  }

  &.link {
    background-color: transparent;
    @apply text-ff02 border-transparent;
  }

  &[data-collapsible] {
    @apply h-auto flex items-center justify-between;

    .icon {
      @apply ml-2;
    }
  }

  &.inline-button {
    @apply bg-transparent inline border-0 w-auto px-0;
    @apply text-ff02;
  }
}
</style>
